module.exports = __webpack_public_path__ + "images/koga_small080dac3bbfab1800f78a6afe485c94ff.png";